import React, { useState } from 'react';
import { MenuItem, MenuDivider, Icon, Colors, Intent, Spinner } from "@blueprintjs/core";
import { IconNames } from '@blueprintjs/icons';

import { subscriptionCustomerPortal } from '../../../services/subscriptionApi';
import {isNoPlan, redirectToExternal} from '../../subscription/utils';
import {useSubscription} from '../../../hooks';

const Loading = React.memo(() => <Spinner intent={Intent.NONE} size={18} />);

const BillingOrUpgrade = () => {
  const currentSubscription = useSubscription();
  const hasSubscription = !!currentSubscription?.subscription_id;

  const [loadingBillingBtn, setLoadingBillingBtn] = useState(false);

  const onBillingClick = (event: any) => {
    /*
    We prevent default in order to not close the menu and show the user that something is loading
     */
    event.preventDefault();
    event.stopPropagation();
    setLoadingBillingBtn(true);

    subscriptionCustomerPortal()
      .then((data: any) => redirectToExternal(data.redirect_url, false))
      .catch(() => setLoadingBillingBtn(false));
  }

  return (
    <>
      {
        (currentSubscription && hasSubscription) && (
          loadingBillingBtn ?
            <Loading /> :
            <MenuItem
              icon={IconNames.CREDIT_CARD}
              text="Billing & Invoices"
              onClick={onBillingClick}
            />
        )
      }
      {
        currentSubscription && !hasSubscription && !isNoPlan(currentSubscription) && (
          <>
            <MenuDivider />
            {
              (
                <MenuItem
                  icon={<Icon
                    icon={IconNames.CLEAN}
                    color={Colors.INDIGO3}
                  />}
                  text={<b>UPGRADE NOW</b>}
                  href='/a/subscription'
                />
              )
            }
          </>
        )
      }
    </>
  );
};

export default BillingOrUpgrade
